<template>
  <div id="content" :style="pageBgStyles">
    <div class="container">
      <h1>{{ title }}</h1>
      <p>{{ content }}</p>

      <div class="row">
        <div class="col-xs-4 col-sm-3 col-centered" v-for="(item, key) in images" v-bind:key="key">
          <img :src="item.src" class="responsive-image"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import pageBgStyles from '../common/js/page-bg-styles'
  import getMeta from '../common/js/get-meta'
  export default {
    mixins: [pageBgStyles, getMeta],
    data () {
      return {
        src: '',
        title: 'Наши успехи и достижения',
        image: '/static/bg2.jpg',
        content: 'Специалисты нашего сервиса проходят обучение и сертификацию у официальных производителей топливного оборудования',
        galleryOptions: {

        },
        images: [

          {
            src: '/static/certificates/5.jpg',
            srcSmall: '/static/certificates/small/5.jpg',
            title: 'test'
          },
          {
            src: '/static/certificates/small/8.jpg',
            title: 'test'
          },

          {
            src: '/static/certificates/small/7.jpg',
            title: 'test'
          },
          {
            src: '/static/certificates/small/9.jpg',
            title: 'test'
          },
          {
            src: '/static/certificates/small/1.jpg',
            title: 'test'
          },
          {
            src: '/static/certificates/small/2.jpg',
            title: 'test'
          },
          {
            src: '/static/certificates/small/3.jpg',
            title: 'test'
          },
          {
            src: '/static/certificates/small/6.jpg',
            title: 'test'
          },
          {
            src: '/static/certificates/small/4.jpg',
            title: 'test'
          }
        ]
      }
    }
  }

</script>

<style lang="stylus" scoped>
.responsive-image
  width 100%
  height auto
  filter brightness(30%)
  transition 0.3s all ease-out
  position relative

  &:hover
    filter none
    transform scale(1.5)
    z-index 3

@media only screen and (min-width: 992px)
  .responsive-image
    &:hover
      transform scale(1.1)
</style>


// WEBPACK FOOTER //
// Achievments.vue?1a3f3fd0